// extracted by mini-css-extract-plugin
export default {"footerBg":"w-z","footerTopLinks":"x-z","footerFeedback":"y-z","footerSocial":"z-z","footerLegalLinks":"A-z","footerIconCards":"B-z","footerBotCopy":"C-z"};